import Avatar from "../../../../components/Avatar/Avatar";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import {useEffect, useState} from "react";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";
import {LiaBatteryEmptySolid} from "react-icons/lia";
import {useSession} from "../../../../redux/Reducers/AuthReducer";
import {IoIosSad} from "react-icons/io";
import {getUri} from "../../../../utils/utils";

function Record({className, onClick, data, name, dp, ...props}) {

    return (
        <div onClick={onClick} className={`flex cursor-pointer gap-2 border-b-[1px] pb-4 ${className}`}>
            <Avatar src={dp}/>
            <div className={"flex flex-col gap-1"}>
                <p className={"font-semibold"}>
                    {name}
                </p>
                {
                    !data?.lastResultData?.answerUrl ? <p>

                            {
                                data?.lastResultData?.aiProofreading || data?.lastResultData?.SelectedOptions
                            }
                        </p> :
                        <audio className={"bg-white mb-2 rounded-full"} controls src={data?.lastResultData?.answerUrl}/>
                }
                <div className={"flex flex-row"}>
                    <p className={"rounded-full text-sm  py-1 text-center px-3  bg-brand-900 text-white"}>
                        Score: {data?.overAllScore} / {
                        data?.lastResultData?.totalScore || 160
                    }
                    </p>
                </div>


            </div>
        </div>

    )
}


export default function MyPracticeSection({className, show, data, id, ...props}) {
    const [form, error, loading, setFormData, actions] = useForm({
        question: id,
    })
    const [showModal, setShowModal] = useState(false);
    const {session} = useSession();

    useEffect(() => {
        actions.post(URLS.getPracticedData).then(response => {
            setFormData({
                data: response?.data,

            })
        })
    }, []);

    function GetComponent() {
        if (loading) return <div className={"mt-12"}>Loading...</div>
        else if (!form?.data || !form?.data?.lastResultData) {
            return (
                <div className={"flex flex-col my-12 gap-2 items-center"}>
                    <IoIosSad className={"text-4xl"}/>

                    <p className={"font-bold text-xl text-center"}>
                        Not Practiced Yet
                    </p>
                    <p className={"text-center"}>
                        Practice and get your score
                    </p>
                </div>
            )
        }

        return (
            <>
                <GenericQuestionModal showModal={showModal} setShowModal={setShowModal}
                                      result={form?.data?.lastResultData}/>
                <Record
                    name={session?.profile?.full_name}
                    dp={getUri(session?.profile?.dp)}
                    data={form?.data}
                    onClick={() => setShowModal(!showModal)}
                />
            </>
        )
    }

    return (
        <div className={`${show ? "flex" : "hidden"} flex flex-col gap-2 mb-4 ${className}`}>

            {
                GetComponent()
            }


        </div>

    )
}